enum Statuses {
  Initial = 'Initial',
  Success = 'Success',
  Error = 'Error',
  Warning = 'Warning'
};

export default Statuses;
